import { render, staticRenderFns } from "./v-modal.vue?vue&type=template&id=518e246d&scoped=true&"
import script from "./v-modal.vue?vue&type=script&lang=js&"
export * from "./v-modal.vue?vue&type=script&lang=js&"
import style0 from "./v-modal.vue?vue&type=style&index=0&id=518e246d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518e246d",
  null
  
)

export default component.exports